import { forwardRef } from "react";

const Input = forwardRef(function Input(
  {
    label,
    error,
    icon: Icon,
    rightElement,
    variant = "default",
    className = "",
    containerClassName = "",
    ...props
  },
  ref
) {
  const isUnderline = variant === "underline";

  return (
    <div className={`space-y-2 ${containerClassName}`}>
      {label && (
        <label
          className={`block font-medium text-primary/70 ${
            isUnderline
              ? "text-[11px] uppercase tracking-[0.14em]"
              : "text-sm"
          }`}
        >
          {label}
        </label>
      )}

      {isUnderline ? (
        <div className="group relative">
          {Icon && (
            <Icon className="pointer-events-none absolute left-0 top-1/2 h-[17px] w-[17px] -translate-y-1/2 text-primary/30 transition-colors duration-300 group-focus-within:text-accent" />
          )}
          <input
            ref={ref}
            className={`
              w-full border-0 bg-transparent py-2.5 text-sm text-primary
              shadow-none outline-none ring-0
              placeholder:text-primary/25
              transition-colors duration-300
              focus:outline-none focus:ring-0 focus-visible:outline-none focus-visible:ring-0
              disabled:cursor-not-allowed disabled:opacity-60
              ${Icon ? "pl-7" : ""}
              ${rightElement ? "pr-10" : ""}
              ${className}
            `}
            {...props}
          />
          {rightElement && (
            <div className="absolute right-0 top-1/2 -translate-y-1/2">
              {rightElement}
            </div>
          )}
          {/* Base line */}
          <span
            className={`pointer-events-none absolute bottom-0 left-0 right-0 h-[2px] ${
              error ? "bg-red-300" : "bg-primary/15"
            }`}
            aria-hidden="true"
          />
          {/* Animated accent underline */}
          {!error && (
            <span
              className="pointer-events-none absolute bottom-0 left-0 h-[2px] w-full origin-left scale-x-0 bg-accent transition-transform duration-300 ease-out group-focus-within:scale-x-100"
              aria-hidden="true"
            />
          )}
        </div>
      ) : (
        <div className="relative">
          {Icon && (
            <Icon className="pointer-events-none absolute left-3.5 top-1/2 h-[18px] w-[18px] -translate-y-1/2 text-primary/35" />
          )}
          <input
            ref={ref}
            className={`
              w-full rounded-xl border bg-white px-4 py-3 text-sm text-primary
              shadow-none outline-none
              placeholder:text-primary/25 transition-all duration-200
              focus:border-accent focus:outline-none focus:ring-4 focus:ring-accent/20
              focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-accent/20
              disabled:cursor-not-allowed disabled:bg-gray-50 disabled:opacity-70
              ${Icon ? "pl-11" : ""}
              ${rightElement ? "pr-12" : ""}
              ${error ? "border-red-400 focus:border-red-400 focus:ring-red-100" : "border-primary/10"}
              ${className}
            `}
            {...props}
          />
          {rightElement && (
            <div className="absolute right-3 top-1/2 -translate-y-1/2">
              {rightElement}
            </div>
          )}
        </div>
      )}

      {error && (
        <p className="text-xs font-medium text-red-500">{error}</p>
      )}
    </div>
  );
});

export default Input;
